import React from 'react'
import { Document, DocumentText, DocumentDownload } from 'iconsax-react'
import { useTheme } from '@mui/material'

import ClickableAlt from '../ClickableAlt'
import LoadingIndicator from '../LoadingIndicator'

import { UseMediaHandleType } from '@SonarCX/hooks/useMediaHandle'

import useStyles from './styles'

type OtherProps = {
  mediaHandle: UseMediaHandleType
  onClick: () => void
}

const PdfIcon = props => (
  <img src='/imgs/pdf-icon.png' alt='PDF logo' {...props} />
)

const Other: React.FC<OtherProps> = ({ mediaHandle, onClick }) => {
  const theme = useTheme()
  const classes = useStyles()
  const { media, isViewable } = mediaHandle

  const isPdf = React.useMemo(
    () => media?.filename?.toLowerCase().endsWith('.pdf') && isViewable,
    [isViewable, media]
  )
  return (
    <>
      <Document
        size={theme.size.xxxl}
        variant='Bold'
        color={theme.palette.primary.main}
        className={classes.icon}
      />

      <ClickableAlt onClick={onClick}>{media.filename}</ClickableAlt>

      <LoadingIndicator
        loading={false}
        onClick={onClick}
        Icon={isPdf ? PdfIcon : isViewable ? DocumentText : DocumentDownload}
      />
    </>
  )
}

export default Other
